var lodashCloneDeep = require('lodash.clonedeep')

const cd = obj => {
  return lodashCloneDeep(obj)
}

export const CloneDeepMixin = {
  install (Vue, options) {
    Vue.mixin({
      methods: {
        $cloneDeep: function (obj) {
          return cd(obj)
        }
      }
    })
  }
}

export const cloneDeep = obj => cd(obj)
